import type { ChoiceOption } from '../ChoiceCards';
import type { OvertimeCompensationType } from '../../../../../shared/dpRequests';

export const OTHER_PROJECT = '__other__';

export const COMPENSATION_OPTIONS: ReadonlyArray<ChoiceOption<OvertimeCompensationType>> = [
    { value: 'compensation', label: 'Compensação', description: 'As horas viram folga ou banco de horas.' },
    { value: 'payment', label: 'Pagamento', description: 'As horas são pagas na folha.' },
];

export const OVERTIME_STEPS = [
    'Envie um e-mail ao seu gestor do projeto (e ao gestor cliente, se houver) solicitando a aprovação para a Hora Extra.',
    'Salve cada e-mail com a aprovação no formato PDF.',
    'Anexe a este chamado o PDF da aprovação do gestor Raro Labs e, se houver cliente, o PDF da aprovação do gestor cliente.',
];
